import React from "react";
import CommonFunc from "./common";
import Path from "./const/path";

function AdminMenu({ activeTab }) {
  return (
    <div className="tab_list_wrapper_login">
      <ul className="tab_list service_tab_list">
        {CommonFunc.DrawTab(Path.buildAdminMenus(), activeTab, "bold")}
      </ul>
    </div>
  );
}

export default AdminMenu;
